var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useReactive } from '../../../utils/hooks/useReactive';
import { Input } from './index';
var cleanedProps = function (props) {
    var derefProps = __assign({}, props);
    delete derefProps.name;
    delete derefProps.initialValue;
    delete derefProps.value;
    delete derefProps.onChange;
    delete derefProps.sourceObj;
    return derefProps;
};
export var ReactiveInput = function (props) {
    var sourceObj = props.sourceObj, name = props.name, initialValue = props.initialValue, onChange = props.onChange;
    var _a = useReactive(name, initialValue), reactiveValue = _a[0], setReactiveValue = _a[1];
    var handleOnchange = function (e) {
        var _a, _b;
        if (sourceObj === null || sourceObj === void 0 ? void 0 : sourceObj.field) {
            setReactiveValue((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value, function (field, value) {
                var _a;
                var _b;
                return onChange(sourceObj.field, __assign(__assign({}, ((_b = sourceObj.source) !== null && _b !== void 0 ? _b : {})), (_a = {}, _a[field] = value, _a)));
            });
        }
        else {
            setReactiveValue((_b = e === null || e === void 0 ? void 0 : e.target) === null || _b === void 0 ? void 0 : _b.value, onChange);
        }
    };
    return (_jsx(Input, __assign({ value: reactiveValue, onChange: handleOnchange }, cleanedProps(props))));
};
